export default class SalesByVendorController {
  constructor(ContentService, moment) {
    this.service = ContentService;
    this.moment = moment;
  }

  $onInit() {
    this.subscriptions = [];

    this.dateFrom = undefined;
    this.dateTo = undefined;
    this.pointOfSales = '';
    this.rows = [];    
  }
  $onDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  findSalesByVendor() {
    this.subscriptions.push(
      this.service.findSalesByVendor({
        date_from: this.dateFrom.format(),
        date_to: this.dateTo.format()
      }).subscribe(
        (sales_by_vendor) => this.rows = sales_by_vendor,
        (err) => console.log(err)
      )
    );
  }
}

SalesByVendorController.$inject = ['ContentService', 'moment'];


// WEBPACK FOOTER //
// ./src/app/pages/sales-by-vendor/sales-by-vendor.controller.js